import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState,useContext,useRef } from "react";
import $ from "jquery";
import "./modalStyle.css";
import { generateRSNAReport, replaceChar, updateRSNAReport, validateSelections } from "../../../helper/RSNAUtilities";
import { generateRSNADynamicReport, getHTMLTemplate } from "../../../../../service/StudyReportService";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import { circlStyle, covidReportState } from "../../../helper/initialData";
import {  generateCovidReport } from "../../../helper/HRCTUtilities";
import {  defaultValueSetHRCTCovidChest, regenerateHRCTCovidReport } from "../../../helper/HRCTChestCovidUtilities";
import { CT_VALIDATION_MESSAGE, CUSTOM_STYLES, REPORT_TITLE } from "../../../../../constants/Constants";
import { validateMriFindings } from "../../../helper/MRISpineUtilities";
import themeContext from "../../../../../context/theme/ThemeContext";
import { iconButtonStyles, iconButtonStylesFunc } from "../../../../../components/Modal/ModalHeader";

const MRISpine = (props) => {

  const [htmlContent,setHTMLContent] = useState();
  const [loading,setLoading] = useState(false);
  const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);
  const {setModel,currentActiveTab,generateMRISpineReport,alertSuccessModal,setAlertSuccessModal} = useContext(studyReportContext);
  const containerRef = useRef(null);
  const getHTMLTemplateCall = async(id)=>{
    setLoading(true);
    let res = await getHTMLTemplate(id);
    console.log("Resposne HTML ");
    console.log(res);
    if(res.status == 200){
      if(res.data.result == "SUCCESS"){
        let content = res.data.data.report;
        setHTMLContent(content);
        setLoading(false);
      }else{
        setLoading(false);
      }
    }
  }

  useEffect(()=>{
    console.log("IDD "+props.id);
      if(props.id != null && props.id != undefined){
          getHTMLTemplateCall(props.id);
      }
  },[props.id])



 

  const {
    setReportModalState,
    reportModalState,
    regenerateHRCT
} = useContext(studyReportContext);

    const contentStyles =  mergeStyleSets({
      root:{
        backgroundColor: 'rgba(0, 0, 0, 0.75);',
        },
        container: {
          display: 'flex',
          width:'900px',
          height:'700px',
          overflowY:'hidden',
          overflowX:'hidden',
          borderRadius:'10px',
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: CUSTOM_STYLES.MODAL_BORDER,
          background: getThemeColor("modal-body")
        },
        scrollableContent:{
            overflowY:'hidden'
        },
        header: [
          {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
            background:getThemeColor("modal-header-footer"),
            cursor: "pointer"
          },
        ],
        footer:[
            {
                display: 'flex',
                justifyContent:"space-between",
                background:getThemeColor("modal-header-footer"),
                padding: '10px'
            }
        ]
      });
    
    const cancelIcon = { iconName: 'Cancel' }; 

    const regenerateMRISpine = () => {

      let selectionsMap = new Map();
      $("#mriSpinePopupContextDiv").find('select, input, textarea').each(function(){
      let tagName = $(this).prop('type');
      if(tagName === "radio" && $(this).is(":checked")){
        selectionsMap[$(this).attr('name')] = $(this).val();
      }
      
      if(tagName !== "radio"){
          selectionsMap[$(this).attr('id')] = $(this).val();
      }
      
      
      });
  
      let submittedValues = JSON.stringify(selectionsMap);


      let response = validateMriFindings();

      if(response != null && (response?.error != null || response?.error != undefined)){
        setAlertSuccessModal(()=>{
          const newItem = {...alertSuccessModal};
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = response.message;
          return newItem;
        });
        return;
      }

      const mriSpineForm = $("form[name='form_mri_spine']");
      let mriSpineData = mriSpineForm.serializeArray();
      mriSpineData.push({
          name: 'values',
          value: submittedValues
      })

      mriSpineData.push({
        name : 'templateName',
        value : 'mri_spine'
      })

      console.log(mriSpineData);
      generateMRISpineReport(mriSpineData,props);
      // let tempContent = props.content;
      // tempContent.reportDetails.report = response;
     
        
     
      //regenerateHRCT(tempContent);
    }

    useEffect(() => {
      if (containerRef.current) {
        const elements = containerRef.current.querySelectorAll('.hrct-body select, .hrct-body textarea, .hrct-body input');
        if (elements.length > 0) {
          elements.forEach(element => {
            element.style.backgroundColor = getThemeColor("modal-body");
            element.style.color = getThemeColor("primary-color");
          });
        }
      }
    }, [htmlContent]);

    return (
        <Modal
        isOpen={props.isModalOpen}
        containerClassName={contentStyles.container}
        dragOptions= {{
            moveMenuItemText: "Move",
            closeMenuItemText: "Close",
            menu: ContextualMenu,
            dragHandleSelector: "#header-id",
            keepInBounds: true,
      }}
        styles={contentStyles}
      >
         {loading &&  <Spinner size={SpinnerSize.large} styles={circlStyle}/>}
        {!loading && <>
        <div id="header-id" className={contentStyles.header}>
          <div id="rsna-title" style={{color: getThemeColor("primary-color")}} className="modal-header-heading-updated">
            {props.content.text}
          </div>
          <IconButton
            styles={iconButtonStylesFunc(getThemeColor)}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={props.hideModal}
          />
        </div>
        <div ref={containerRef} id="covidSRPopupContext" 
        style={{color: getThemeColor("primary-color"),
        colorScheme:themeName!='light'?'inherit':'none',
        accentColor:'rgb(0,117,255)'
        }}
        className={`hrct-body ${getScrollBarStyleForTheme(themeName,"modal-scroll-rsna")}`} 
        dangerouslySetInnerHTML={{__html: htmlContent}}

        >
        </div>
        <div className={contentStyles.footer}>
            <div style={{display:'flex'}}>
                <DefaultButton text="Cancel" onClick={props.hideModal} />
                <PrimaryButton style={{marginLeft:'10px'}} text="Reset" onClick={()=>getHTMLTemplateCall(props.id)} />
            </div>
           
            <PrimaryButton text="Regenerate" onClick={()=>{
              
              regenerateMRISpine();
              }} />
        </div></>
        }
      </Modal>
    )
}

export default MRISpine;